import styles from "./termsAndConditions.module.scss";
import Layout from "../../components/layout";

export default function TermsAndConditions() {
  return (
    <Layout className={styles.root}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>
          Campagnevoorwaarden Porsche campagne “Garage Mentality”.
        </h1>
      </div>
      <h2>Artikel 1 Algemeen</h2>
      <ol className={styles.itemList}>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Deze Campagnevoorwaarden (hierna: de “Campagnevoorwaarden”) zijn van
            toepassing op de Porsche campagne: ‘Garage Mentality&#39; (hierna:
            de “Campagne”).
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            De Campagne wordt georganiseerd door Pon’s Automobielhandel B.V.,
            Business Unit Porsche gevestigd en kantoorhoudende te Leusden,
            Zuiderinslag 8, 3833 BP en geregistreerd bij de Kamer van Koophandel
            onder nummer 31038797 (hierna: “Porsche”).
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            De Campagneperiode loopt van{" "}
            <b>6 maart 2023 tot en met 7 mei 2023</b> (eindigt 23.59 uur)
            (hierna: de “Campagneperiode”). Na afloop van de Campagneperiode is
            deelname niet langer mogelijk.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Deelnemers aan de Campagne (hierna: de “Deelnemer”, “Deelnemers’)
            verklaren door hun deelname aan de Campagne akkoord te gaan met deze
            Campagnevoorwaarden.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Porsche behoudt zich het recht voor om de Campagne, eenzijdig en
            zonder voorafgaande kennisgeving, te beëindigen, te onderbreken of
            te wijzigen en/of de Campagnevoorwaarden te wijzigen zonder op enige
            wijze tot schadevergoeding gehouden te zijn jegens de Deelnemers. De
            Campagnevoorwaarden zullen echter nooit ten nadele van de Deelnemers
            worden gewijzigd.
          </p>
        </li>
      </ol>
      <h2>Artikel 2 De Campagne</h2>
      <p>De Campagne werkt als volgt:</p>
      <ol className={styles.itemList}>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            De Campagne vindt online plaats op garagementality.porsche.nl
            (hierna te noemen: “Site”). Het vervolg van de Campagne bestaat uit
            de volgende onderdelen: advies vragen via de AI-omgeving op het
            gebied van ondernemerschap en meer inspiratie opdoen via Discovered
            en/of aanmelden voor de Discovered nieuwsbrief.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Campagneperiode loopt van <b>6 maart 2023 tot en met 7 mei 2023</b>{" "}
            (eindigt 23.59 uur).
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            De Deelnemer kan de AI op de Site advies vragen op het gebied van
            ondernemerschap en meer inspiratie opdoen via Discovered (
            <a
              href="https://discovered.porsche.nl"
              target="_blank"
              rel="noopener noreferrer"
            >
              discovered.porsche.nl
            </a>
            ) en/of aanmelden voor de Discovered nieuwsbrief.
          </p>
        </li>
      </ol>
      <h2>Artikel 3 Deelname</h2>
      <ol className={styles.itemList}>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            De Campagne vindt online plaats op garagementality.porsche.nl
            (hierna te noemen: “Site”). Het vervolg van de Campagne bestaat uit
            de volgende onderdelen: advies vragen via de AI-omgeving op het
            gebied van ondernemerschap en meer inspiratie opdoen via Discovered
            en/of aanmelden voor de Discovered nieuwsbrief.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Deelname aan deze Actie en aanmelden voor de nieuwsbrief van
            Discovered is kosteloos. Kosten voor eventuele internetverbinding
            zijn voor rekening van de Deelnemer.
          </p>
        </li>
      </ol>
      <h2>Artikel 4 Aansprakelijkheid</h2>
      <ol className={styles.itemList}>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Porsche en de door haar ingeschakelde hulppersonen en/of derden,
            waaronder EssenceMediacom, Dentsu Creative Amsterdam, Glasnost
            International B.V. en Gemini Design B.V., zijn in geen geval
            aansprakelijk voor enige schade, van welke aard dan ook, en/of ander
            nadeel veroorzaakt door, of op enige wijze verband houdend met de
            Campagne, inclusief doch niet beperkt tot deelname aan de Campagne
            en het onvermogen om deel te nemen. De Deelnemer vrijwaart Porsche
            van aanspraken van derden in verband met deze Campagne en/of in
            verband met het handelen of nalaten van de Deelnemer.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Ondanks de grootst mogelijke zorg die Porsche aan het beheer van
            haar website(s) en de organisatie van de Campagne besteedt, is het
            mogelijk dat de verstrekte en/of weergegeven informatie onvolledig
            of onjuist is. Druk-, spel-, zetfouten of andere vergelijkbare
            fouten in het door Porsche openbaar gemaakte materiaal, van welke
            aard dan ook, kunnen Porsche niet worden tegengeworpen en kunnen op
            geen enkele wijze een verplichting voor Porsche in het leven roepen.
            Behoudens voor zover dit wettelijk is toegestaan, mag niets van deze
            site(s) worden verveelvoudigd, bewerkt of openbaar gemaakt, in welke
            vorm of op welke wijze dan ook, zonder voorafgaande schriftelijke
            toestemming van Porsche.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            De AI draait op GPT-3, of Generative Pre-trained Transformer 3.
            GPT-3 is een groot taalverwerkings-AI-model ontwikkeld door OpenAI.
            Het is ontworpen om tekst te genereren op basis van een gegeven
            prompt. Om GPT-3 te gebruiken, geeft u het een prompt, bijvoorbeeld
            een vraag of een verklaring, en dan genereert het model tekst als
            antwoord op die prompt. De tekst die het model genereert is
            gebaseerd op de patronen en relaties die het heeft geleerd van de
            gegevens waarop het is getraind, waaronder een grote dataset van
            menselijke taal. Porsche kan op geen enkele manier aansprakelijk
            worden gesteld voor de antwoorden die vanuit de AI worden
            geformuleerd.
          </p>
        </li>
      </ol>
      <h2>Artikel 5 Slotbepalingen</h2>
      <ol className={styles.itemList}>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Op deze Campagnevoorwaarden is Nederlands recht van toepassing.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Porsche is niet verantwoordelijk voor eventuele technische
            problemen, waaronder het uitvallen van de internetverbinding,
            waardoor eventuele deelname niet mogelijk is.
          </p>
        </li>
        <li className={styles.item}>
          <p className={styles.paragraph}>
            Bij vragen en/of klachten over deze Campagne kunt u per e-mail
            contact opnemen met Porsche via{" "}
            <a href="mailto:marketing@porsche.nl">marketing@porsche.nl</a>{" "}
            o.v.v. Porsche Garage Mentality. Porsche reageert maximaal binnen 4
            weken per e-mail naar aanleiding van de klacht.
          </p>
        </li>
      </ol>
      Januari 2023
    </Layout>
  );
}
